import { connect } from 'react-redux'
import HelpLink from './HelpLink'

const mapStateToProps = (state, ownProps) => ({
  baseHelpUrl: state.config.baseHelpUrl || 'http://h.daptiv.com/Help/PPM/J5_help.htm'
})

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpLink)



// WEBPACK FOOTER //
// ./src/components/HelpLink/index.js